import type { AlertFilters, TransactionAlert } from '../types/alerts';
import type { TransactionsV2Filters, TransactionsV2Result } from '../types/transactions';

type AlertsResult = { alerts: TransactionAlert[]; count: number; hasMore: boolean; nextCursor: string | null };
type InvoiceScopeFilters = { clientId?: string; clientIds?: string[] };

/** Last-good rows are useful only within one book; client identity is the hard boundary. */
export function preserveSameBookAlerts<T extends AlertsResult>(
  previous: T | undefined,
  filters: AlertFilters,
  previousFilters: AlertFilters | undefined
): T | undefined {
  return previousFilters?.clientId === filters.clientId ? previous : undefined;
}

export function preserveSameBookTransactions(
  previous: TransactionsV2Result | undefined,
  filters: TransactionsV2Filters,
  previousFilters: TransactionsV2Filters | undefined
): TransactionsV2Result | undefined {
  return previousFilters?.clientId === filters.clientId ? previous : undefined;
}

function invoiceClientScope(filters: InvoiceScopeFilters): string {
  if (filters.clientId) return `client:${filters.clientId}`;
  if (filters.clientIds?.length) return `clients:${[...filters.clientIds].sort().join(',')}`;
  return 'all-clients';
}

/** The actual queryKey filter object supplies both current and previous invoice scope. */
export function preserveSameClientInvoices<T>(
  previous: T | undefined,
  filters: InvoiceScopeFilters,
  previousFilters: InvoiceScopeFilters | undefined
): T | undefined {
  return previousFilters && invoiceClientScope(previousFilters) === invoiceClientScope(filters) ? previous : undefined;
}
